<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    };
  },
  data () {
    return {
      // theme: this.$store.state.app.themeColor,
      isRouterAlive: true
    };
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }

  }
}
</script>

<style>
  html,body{
    width: 100%;
    height: 100%;
    background: #F2F3F7;
    overflow: auto;
  }
  .app-main{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue